/**
 * @author Charles Blais <charles.blais@nrcan-rncan.gc.ca>
 */
import ContainerNetwork from './containers/container-network';

import { Outlet } from 'react-router-dom';


const App = () => {
  return (
    <>
      <Outlet />
      <ContainerNetwork />
    </>
  )
}

export default App;
